import { modalBibliographySearchConditionStore } from '@/store'
import { ModalBibliographySearchConditionStoreInterface } from '@/store/ModalBibliographySearchConditionStore'

export class ModalBibliographySearchConditionService {
  public open(params: ModalBibliographySearchConditionStoreInterface) {
    modalBibliographySearchConditionStore.open(params)
  }

  public close() {
    modalBibliographySearchConditionStore.close()
  }
}
